import enUS from '@i18n/wpI18n/en-US.json'
import zhHK from '@i18n/wpI18n/zh-HK.json'
import zhTW from '@i18n/wpI18n/zh-TW.json'

import { getWordPressLocale } from '@utils/getWordPressLocale'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  zh_TW: {
    wpCart: zhTW,
  },
  en_US: {
    wpCart: enUS,
  },
  zh_HK: {
    wpCart: zhHK,
  },
}

const wordPressLocale = getWordPressLocale()
const language = wordPressLocale
const wpCartInstance = i18n.createInstance()

wpCartInstance
  .use(initReactI18next)
  .init({
    resources,
    lng: language,
    interpolation: {
      escapeValue: false,
    },
    saveMissing: true,
    defaultNS: 'wpCart',
  })

export { wpCartInstance }
